module.exports = __webpack_public_path__ + "static/media/notification.28dadfdf.mp3";